import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { clientAPI } from "../api/client";
import { NumberOfPerPage } from "../utils/globalVariable";
import { customDateFormat } from "../utils/utils";

const NUMBER_NFT_PER_PAGE = NumberOfPerPage.receiveSalary;
const queryKey = "receiveSalary";

async function fetchReceiveSalary(
  currentPage,
  search,
  saleBlockId, 
  saleAreaId
) {
  try {
    const options = {
      limit: NUMBER_NFT_PER_PAGE,
      page: currentPage,
    };

    if (search !== undefined) options.search = search;
    if (saleBlockId) options.saleBlockId = saleBlockId;
    if (saleAreaId) options.saleAreaId = saleAreaId;

    const queryParams = new URLSearchParams(options).toString();
    let data = await clientAPI("get", `/updateBusinessCategoryRequest/?${queryParams}`);
    const totalPages = Math.ceil(data?.pagination?.total / NUMBER_NFT_PER_PAGE);
    const entries = data?.pagination?.total;
    const startEntry =
      (data?.pagination?.page - 1) * data?.pagination?.limit + 1;
    const endEntry = Math.min(
      data?.pagination?.page * data?.pagination?.limit,
      entries
    );

    const newData = data?.items.map((item, index) => {
      return {
        id: item?._id || "",
        status: item?.status || "-",
        codeEmployee: item?.employeeObject?.code || "-",
        nameEmployee: item?.employeeObject?.fullName || "-",
        saleArea: item?.employeeObject?.saleArea?.name || "-",
        saleBlock: item?.employeeObject?.saleBlock?.name || "-",
        createdAt: item?.createdAt ? customDateFormat(item?.createdAt) : "-",
      };
    });

    return { data: newData, totalPages, entries, startEntry, endEntry };
  } catch (error) {
    console.error("Error fetching onLeave data:", error);
    return { data: [], totalPages: 0 };
  }
}

export function useReceiveSalary(search, saleBlockId, saleAreaId) {
  const [currentPage, setCurrentPage] = useState(1);
  const { data, refetch, isLoading, isRefetching } = useQuery({
    queryKey: [queryKey, currentPage, search, saleBlockId, saleAreaId],
    queryFn: () =>
      fetchReceiveSalary(currentPage, search, saleBlockId, saleAreaId),
    refetchOnWindowFocus: false,
    staleTime: 30000,
    keepPreviousData: true,
    onError: (error) => {
      console.error("Error fetching update Business Category Request data:", error);
    },
  });

  const nextPage = () => {
    if (currentPage < data?.totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return {
    onReceiveSalary: data?.data,
    totalPages: data?.totalPages,
    refetch,
    isLoading,
    isRefetching,
    prevPage,
    nextPage,
    setCurrentPage,
    currentPage,
    entries: data?.entries,
    startEntry: data?.startEntry,
    endEntry: data?.endEntry,
  };
}
